import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, RouteReuseStrategy, withComponentInputBinding } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideTanStackQuery, QueryClient } from '@tanstack/angular-query-experimental';

import {
  authInterceptor,
  provideCoreConfig,
  provideSession,
  timeoutInterceptor,
  tokenRefreshInterceptor,
  trackingInterceptor,
} from '@movilidad/app-core';
import { prefersReducedMotion } from '@movilidad/app-ui';
import { provideTextScale } from '@movilidad/app-ui/text-scale';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { PassengerSessionHooks, SESSION } from './app/session';
import { coreConfig } from './environments/core-config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideCoreConfig(coreConfig),
    ...provideSession(SESSION, PassengerSessionHooks),
    // WCAG 1.4.4: el texto llega a 200 %. Las pantallas nacen sin alturas fijas, a diferencia de lo que
    // Movilidad midió pantalla por pantalla para sus techos (TEC-204).
    provideTextScale({ content: 2, ui: 2, title: 2, display: 2 }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      // Las transiciones son las de Ionic: deslizar en iOS, con el gesto atrás, y el fundido de Android. Pero
      // no respetan "reducir movimiento", y al ser Web Animations el CSS no las alcanza. Se lee al arrancar.
      animated: !prefersReducedMotion(),
      innerHTMLTemplatesEnabled: false,
      useSetInputAPI: true,
    }),
    provideHttpClient(withInterceptors([trackingInterceptor, timeoutInterceptor, authInterceptor, tokenRefreshInterceptor])),
    provideRouter(routes, withComponentInputBinding()),
    provideTanStackQuery(
      new QueryClient({
        defaultOptions: {
          // El interceptor ya reintenta con backoff: TanStack multiplicaría los intentos.
          queries: { retry: false, refetchOnWindowFocus: false, refetchOnReconnect: false },
        },
      })
    ),
  ],
}).catch((err) => console.error('Bootstrap failed:', err));
